import { selectData } from '../../../utils/select-data';
import { requiredHeaders } from '../../../models/required-headers';
import { withJwt } from '../../../utils/with-jwt';
import { mapManagementServiceEnvironment } from '../map-management-service-environment';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Deletes one rule based on ID
 * @param id The ID of the rule being deleted
 * @returns A rule
 */
export function deleteRules(this: unknown, id: number) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${mapManagementServiceEnvironment.resolve(this).rulesUrl}/${id}`,
        {
          method: 'DELETE',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
      })
    )
  );
}
